var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.1666C15.0626 19.1666 19.1667 15.0626 19.1667 9.99998C19.1667 4.93737 15.0626 0.833313 10 0.833313C4.9374 0.833313 0.833344 4.93737 0.833344 9.99998C0.833344 15.0626 4.9374 19.1666 10 19.1666Z",
    fill: "#D3E9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 9.99998L10 13.6666L13.6667 9.99998",
    fill: "#D3E9E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 9.99998L10 13.6666M10 13.6666L13.6667 9.99998M10 13.6666V6.33331M19.1667 9.99998C19.1667 15.0626 15.0626 19.1666 10 19.1666C4.9374 19.1666 0.833344 15.0626 0.833344 9.99998C0.833344 4.93737 4.9374 0.833313 10 0.833313C15.0626 0.833313 19.1667 4.93737 19.1667 9.99998Z",
    stroke: "#24352F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1b7d7ee5.svg";
export { ForwardRef as ReactComponent };